import {DimensionValue, StyleSheet} from 'react-native';

import {TAB_BAR_HEIGH} from '/component/layout/TabLayout/TabLayout.style';

const VIEWPORT_HEIGHT_WITHOUT_TAB_BAR: DimensionValue =
  `calc(100vh - ${TAB_BAR_HEIGH}px - 20px)` as DimensionValue;

export const styles = StyleSheet.create({
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    maxHeight: VIEWPORT_HEIGHT_WITHOUT_TAB_BAR,
    overflow: 'hidden' as const,
  },
  dataContainer: {
    flex: 1,
    minHeight: 0,
    overflow: 'scroll' as const,
  },
});
